<template>
    <b-input-group class="btn-search" size="lg">
      <b-form-input :style="inner_style" :value="this.value" :readonly="readonly"
                    @input="update_input"
                    :formatter="formatter[this.type]" class="inner-text" :placeholder='this.placeholder'></b-form-input>
      <b-input-group-append>
        <b-button variant="white" class="inner-btn" style="z-index: 0" @click="do_click">
          <b-icon icon="search" variant="primary"></b-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
</template>

<script>
import utils from "../../../../../config/utils";

export default {
  name: 'InputSearch',
    data() {
      return {
        formatter: {
          "number": this.phoneNumberFormatter,
          "string": (val) => val,
        }
      }
    },
    methods: {
      do_click:function (){
        this.$emit("click", this.value);
      },

      phoneNumberFormatter(value) {
        return utils.formatPhoneNumber(value);
      },

      update_input: function (val){
         this.$emit('input', val);
      },
    },
    props:{
      placeholder:{
        type: String,
        },
      value:{
        type: String,
      },
      type:{
        type: String,
      },
      readonly:{
        type: Boolean,
      },
      inner_style:{
        type: String,
      }

    },
}
</script>

<style scoped lang="scss">
  @import '../../../../../assets/css/_vars.scss';
  @import '../../../../../assets/css/main/admin/Admin.scss';
  .btn-search {
    border:1px solid $border;
    border-radius: 0.25rem;
  }
  .inner-btn{
    border: none;
    font-size: $fs_17!important;
  }
  .inner-text{
    text-align: center;
    border: none;
    font-size: $fs_18;
    font-family: $korean_gd_14_r;
  }

</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/controls/input_search.vue